import { paywallQueries } from "@circle-react/lib/queries/paywalls";
import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query";

import type { Paywall } from "@/react/types/Paywall";

const paywallStatusDefault: string[] = [];

interface UsePaywallListParams {
  communityMemberId?: string | number | null;
  options?: Omit<UseQueryOptions<Paywall[]>, "queryKey">;
  spaceIds?: Array<string | number | undefined>;
  status?: string[];
}

interface UsePaywallListReturn {
  paywallsListQuery: ReturnType<typeof useQuery<Paywall[]>>;
}

export const usePaywallList = ({
  communityMemberId,
  status = paywallStatusDefault,
  options = {},
  spaceIds = [],
}: UsePaywallListParams): UsePaywallListReturn => {
  const { queryKey, queryFn } = paywallQueries.list({
    communityMemberId,
    status,
    spaceIds,
  });

  const paywallsListQuery = useQuery<Paywall[]>({
    queryKey,
    queryFn,
    ...options,
  });

  return {
    paywallsListQuery,
  };
};
